import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TabBarItem from './TabBarItem';
import HomeIcon from '../../public/static/images/tab_bar/home.svg';
import BookmarksIcon from '../../public/static/images/tab_bar/bookmarks.svg';
import PlusIcon from '../../public/static/images/tab_bar/plus.svg';
import ProfileIcon from '../../public/static/images/tab_bar/cabinet.svg';
import HamburgerIcon from '../../public/static/images/tab_bar/hamburger.svg';
import { useBridgeState } from '../../bridge';

const TabBar = () => {
  const { t } = useTranslation();
  const { isWebView, insets } = useBridgeState();

  const bottomInsetStyles = useMemo(() => {
    if (isWebView) {
      return {
        height: insets.bottom + 53
      };
    }
    return null;
  }, [isWebView, insets]);

  const tabBarItems = [
    {
      name: 'home',
      path: '/',
      routes: ['/', '/[...search]'],
      icon: HomeIcon,
      text: t('pages.tab_bar.buttons.search'),
      isLink: true,
      iconW: 20,
      iconH: 20
    },
    {
      name: 'bookmarks',
      path: '/bookmarks',
      routes: ['/bookmarks'],
      icon: BookmarksIcon,
      text: t('pages.tab_bar.buttons.bookmarks'),
      isLink: true,
      iconW: 24,
      iconH: 21
    },
    {
      name: 'new-item',
      path: '/items/new',
      routes: ['/items/new'],
      icon: PlusIcon,
      text: t('pages.tab_bar.buttons.add'),
      isDefaultLink: true,
      iconW: 45,
      iconH: 45
    },
    {
      name: 'profile',
      path: '',
      routes: [],
      icon: ProfileIcon,
      text: t('pages.tab_bar.buttons.cabinet'),
      isProfileTab: true,
      iconW: 20,
      iconH: 20
    },
    {
      name: 'more',
      path: '',
      routes: [],
      icon: HamburgerIcon,
      text: t('pages.tab_bar.buttons.more'),
      isSideMenuTab: true,
      iconW: 26,
      iconH: 20
    }
  ];

  return (
    <div className="tab-bar-container">
      <div
        className="tab-bar"
        {...(bottomInsetStyles ? { style: bottomInsetStyles } : {})}
      >
        <ul className="tab-bar__list">
          {tabBarItems.map((item, i) => (
            <TabBarItem key={`item_${i}`} {...{ item }} />
          ))}
        </ul>
      </div>
    </div>
  );
};

TabBar.propTypes = {
  headerTitle: PropTypes.string
};

export default TabBar;
